import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { useAppTranslation } from '../../i18n/useAppTranslation';
import { tokens } from '../../theme/tokens';
import { formatDate } from '../../utils/productDetailHelpers';
import { lifecycleStageOf } from '../../utils/productBrowserFilterState';

/**
 * The Announced / Pre-order chip of a pre-release product (flag `preorder_lifecycle`,
 * MOT-143) on the product browser's cards and list rows; nothing for a released one.
 * The tooltip says when it ships.
 */
const ProductLifecycleChip: React.FC<{ lifecycle?: { stage?: string; releaseDate?: string | null } | null }> = ({ lifecycle }) => {
  const { t } = useAppTranslation();
  const stage = lifecycleStageOf({ lifecycle });
  if (stage === 'released') return null;
  const tone = stage === 'preorder' ? tokens.signal.caution : tokens.signal.info;
  const date = (lifecycle?.releaseDate && formatDate(lifecycle.releaseDate)) || t('productLifecycle.dateTbd');
  return (
    <Tooltip title={t(`productLifecycle.hint.${stage}`, { date })}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          height: 20,
          px: 0.875,
          borderRadius: '4px',
          bgcolor: tone.tint,
          border: `1px solid ${tone.border}`,
          color: tone.ink,
          fontSize: '0.6875rem',
          fontWeight: 600,
        }}
      >
        {t(`productLifecycle.stage.${stage}`)}
      </Box>
    </Tooltip>
  );
};

export default ProductLifecycleChip;
